import RootRoute from "./routes";
import { GlobalStyle } from "./shared/styled";

function App() {
  return (
    <>
      <GlobalStyle />
      <RootRoute />
    </>
  );
}

export default App;
